import { Box, Typography } from '@mui/material';

import { DialogUI } from '../Interface';

const InventoryConversionDefinitionDialog = ({ open, handleClose, items, onSelect }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={'Találatok'}
      sx={{
        '& .MuiDialog-container': { alignItems: 'flex-start' },
        '& .MuiPaper-root': { width: '100%', maxWidth: '800px', height: '70vh' },
        '& .MuiDialogContent-root': { overflowY: 'auto', maxHeight: '100%' },
        marginTop: '40px',
      }}
    >
      {items?.length === 0 ? (
        <Box>Nincs találat.</Box>
      ) : (
        <Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {items?.map((item) => (
            <Box
              key={item.id}
              onClick={() => {
                onSelect(item);
                handleClose();
              }}
              sx={{
                px: 1.5,
                py: 1,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                cursor: 'pointer',
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              <Typography variant="subtitle1" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
                {[item?.itemCode, item?.item?.itemName].filter(Boolean).join(' - ')}
              </Typography>

              {item?.priceList?.name ? (
                <Typography variant="caption" color="text.secondary" component="div" sx={{ display: 'block', mt: 0.25 }}>
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Forrás árlista:
                  </Box>{' '}
                  {item.priceList.name}
                </Typography>
              ) : null}

              {item?.note ? (
                <Typography variant="caption" color="text.secondary" component="div" sx={{ display: 'block', mt: 0.25 }}>
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Megjegyzés:
                  </Box>{' '}
                  {item.note}
                </Typography>
              ) : null}
            </Box>
          ))}
        </Box>
      )}
    </DialogUI>
  );
};

export default InventoryConversionDefinitionDialog;
